import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data = {
  dataSuggest: [
    {
      // developers
      developers: [
        {
          img: require('@/assets/images/portrait/small/avatar-s-4.jpg'),
          name: 'Rena Brant',
          email: 'nephrod@preany.co.uk',
          time: '21/05/2019',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          name: 'Mariano Packard',
          email: 'seek@sparaxis.org',
          time: '14/01/2018',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-24.jpg'),
          name: 'Risa Montufar',
          email: 'vagary@unblist.org',
          time: '10/08/2019',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-15.jpg'),
          name: 'Maragaret Cimo',
          email: 'designed@insanely.net',
          time: '01/12/2019',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-7.jpg'),
          name: 'Jona Prattis',
          email: 'unwieldable@unblist.org',
          time: '21/05/2019',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-5.jpg'),
          name: 'Edmond Chicon',
          email: 'museist@anaphyte.co.uk',
          time: '15/11/2019',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-25.jpg'),
          name: 'Abbey Darden',
          email: 'astema@defectively.co.uk',
          time: '07/05/2019',
        },
      ],

      // designers
      designers: [
        {
          img: require('@/assets/images/portrait/small/avatar-s-10.jpg'),
          name: 'Seema Moallankamp',
          email: 'fernando@storkish.co.uk',
          time: '13/08/2017',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-2.jpg'),
          name: 'Charleen Warmington',
          email: 'furphy@cannibal.net',
          time: '11/08/1891',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-25.jpg'),
          name: 'Geri Linch',
          email: 'insignia@markab.org',
          time: '18/01/2015',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-23.jpg'),
          name: 'Shellie Muster',
          email: 'maxillary@equalize.co.uk',
          time: '26/07/2019',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-20.jpg'),
          name: 'Jesenia Vanbramer',
          email: 'hypotony@phonetist.net',
          time: '12/09/2017',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-23.jpg'),
          name: 'Mardell Channey',
          email: 'peseta@myrica.com',
          time: '11/11/2019',
        },
        {
          img: require('@/assets/images/portrait/small/avatar-s-24.jpg'),
          name: 'Lilliana Stroman',
          email: 'lilliana@stroman.com',
          time: '12/11/2020',
        },
      ],

      // pages
      pages: [
        { icon: 'MailIcon', name: 'Email' },
        { icon: 'MessageSquareIcon', name: 'Chat' },
        { icon: 'CheckSquareIcon', name: 'Todo' },
        { icon: 'CalendarIcon', name: 'Calendar' },
        { icon: 'GridIcon', name: 'Kanban' },
        { icon: 'FileTextIcon', name: 'Invoice' },
        { icon: 'SaveIcon', name: 'File Manager' },
        { icon: 'ShoppingCartIcon', name: 'ECommerce' },
      ],

      // company
      company: [
        { id: '8F97912B-FA77-4929-B26B-08D8CE6C992C', name: 'ทดสอบ นิติบุคคล' },
        { id: '7DF4AC01-1875-4490-2EB2-08D8E82EA8B1', name: 'ทดสอบ นิติบุคคล ODR1 Update' },
        { id: '42C300BA-2BB8-45DD-381F-08D8EDD430AC', name: 'ทดสอบกกกกบบบ' },
        { id: 'BF3FAA60-A790-4A60-2052-08D957FE0907', name: 'ทดสอบผู้ประกอบ' },
        { id: 'A3B3CE71-4ECF-4878-AF79-08D95733ADF5', name: 'ทดสอบผู้ประกอบการบริษัท' },
        { id: 'F059382B-06A9-4D09-B675-08D9526B3101', name: 'ทดสอบผู้ประกอบการบุคคล' },
        { id: '38065F2B-D244-45B0-BDFA-08D8E926BE63', name: 'ทดสอบมหาชน' },
        { id: 'BA2408BE-625B-457F-9C31-0098A1CFFE42', name: 'ทดสอบห้างหุ้นส่วน' },
        { id: '17CEA510-CACE-439A-D8E9-08D96C36811A', name: 'บริษัท โจทดสอบ2 จำกัด' },
        { id: 'E590C59C-7D6B-43F3-BF77-08D971320193', name: 'บริษัท โจทดสอบ3 จำกัด' },
        { id: '494A3C00-BD83-4AB9-B39B-CF929FCAD02D', name: 'บริษัท โจทดสอบแอนสปา จำกัด' },
        { id: '4C761D81-6B9C-4A82-D8E7-08D96C36811A', name: 'บริษัท โจรีดดิ้งทดสอบ จำกัด' },
        { id: '225DABE1-3D85-46CE-A07C-CCF9E6A115F1', name: 'บริษัท นิธินันท์ ทดสอบ' },
        { id: '89E3AAE5-8A71-4510-9E85-B01516D11AD0', name: 'บริษัททดสอบขายตรง' },
        { id: '4D5C6498-EDE7-454C-B59A-BF2F394F3D6E', name: 'บริษัททดสอบโฆษณา' },
        { id: '1F2C3A81-78E5-4984-A5BB-1EECFDEFC28B', name: 'บริษัททดสอบจังหวัดเเละต่างประเทศ' },
        { id: '6AE80233-B3BB-447A-AB26-91B4E868E492', name: 'บริษัททดสอบฉลาก' },
        { id: '13B8B722-EA06-499D-BF1C-A66DBAAAA2E8', name: 'บริษัททดสอบสัญญา' },
        { id: 'C644EE7C-AFD0-416E-9C0F-15440B53474E', name: 'ร้านค้าทดสอบ 1' },
      ],
    },

  ],
}
/* eslint-disable global-require */

mock.onGet('/autosuggest/data').reply(() => [200, data.dataSuggest])
